// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1uYzK","tab":"ProcedureTabs_tab__1Jbrs"};